"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcelebration = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 65 60",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcelebration` : '') + (description ? ` desc-brandedcelebration` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcelebration"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcelebration"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.26 3.88a1.48 1.48 0 1 0 0-2.96 1.48 1.48 0 0 0 0 2.96Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37.75 26.35a1.97 1.97 0 1 0 0-3.95 1.97 1.97 0 0 0 0 3.95Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25 9.17a1.97 1.97 0 1 0 .01-3.95 1.97 1.97 0 0 0 0 3.95Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M46.64 2.24a1.12 1.12 0 1 0 0-2.24 1.12 1.12 0 0 0 0 2.24Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.39 25.4a1.12 1.12 0 1 0 0-2.25 1.12 1.12 0 0 0 0 2.25Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M63.13 16.43a1.12 1.12 0 1 0 0-2.24 1.12 1.12 0 0 0 0 2.24Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M57.88 36.6a1.12 1.12 0 1 0 0-2.24 1.12 1.12 0 0 0 0 2.24Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M56.15 25.4a1.97 1.97 0 1 0 0-3.95 1.97 1.97 0 0 0 0 3.95Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M63.5 29.88a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: "#F04C24"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37.75 9.17a1.97 1.97 0 1 0 0-3.95 1.97 1.97 0 0 0 0 3.95Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M58.73 6.18a1.97 1.97 0 1 0 .01-3.95 1.97 1.97 0 0 0 0 3.95Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m47.76 11.94-.4.37-.38-.37a2.7 2.7 0 0 0-4.2.65l-.05.1a2.4 2.4 0 0 0 .45 2.7l3.94 3.93c.14.13.37.13.5 0l3.86-3.86c.8-.75.99-1.91.49-2.87l-.06-.1a2.7 2.7 0 0 0-4.15-.55Z",
    fill: "#F04C24"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m.13 56.2 14.95-33.3c-.67 3.51 3.4 9.85 7.83 14.27 5.39 5.37 11.44 8.52 14.57 7.71-5.43 2.43-33.25 14.8-33.67 14.99-.77.35-1.93-.02-2.79-.89-.87-.85-1.24-2.01-.89-2.78Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m.13 56.2 14.95-33.3c-.67 3.5 3.4 9.84 7.82 14.26L1 58.97c-.85-.86-1.22-2-.87-2.77Z",
    fill: "#FFC599"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.63 54.58c-8.78 3.94 1.8-.79-7 3.14a67.61 67.61 0 0 1-6-7.09l3.58-7.97a50.63 50.63 0 0 0 9.42 11.92Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.73 49.28 5.6 54.4a63.69 63.69 0 0 1-2.97-3.76l3.58-7.97a50.43 50.43 0 0 0 4.52 6.62Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.91 37.17c6.25 6.22 13.38 9.48 15.83 7.03 2.43-2.42-.74-9.47-7.06-15.78-6.33-6.3-13.41-9.44-15.84-7.04-2.83 2.82 1.89 10.63 7.07 15.8Z",
    fill: "#F04C24"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.5 40.37c-3.43-4.64-5.52-9.55-5.96-13.93a7 7 0 0 1-.46-3.53l-5.4 12.06a50.25 50.25 0 0 0 5.2 8.69 55.8 55.8 0 0 0 7.29 8.04l7.32-3.26a38.97 38.97 0 0 1-7.98-8.07Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m31.67 28.41-8.77 8.75c-5.18-5.17-9.88-12.97-7.06-15.78 2.43-2.4 9.5.74 15.83 7.03Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m15.08 22.9-5.4 12.07a50.25 50.25 0 0 0 5.2 8.69l.66.83 5.22-5.2c-3-4.32-4.82-8.81-5.22-12.86a7 7 0 0 1-.46-3.52Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m48.75 31.85-.24.23-.24-.23a1.63 1.63 0 0 0-2.59.4l-.03.07c-.26.58-.15 1.26.28 1.72l2.43 2.5c.08.08.22.08.3 0l2.38-2.45c.49-.48.6-1.22.3-1.83l-.03-.07a1.62 1.62 0 0 0-2.56-.35Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m28.75 14.48-.24.23-.24-.23a1.63 1.63 0 0 0-2.59.4l-.03.07c-.26.58-.15 1.26.28 1.72l2.43 2.5c.08.08.22.08.3 0l2.38-2.45c.49-.48.6-1.22.3-1.83l-.04-.07a1.62 1.62 0 0 0-2.55-.35Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = brandedcelebration;